import React, { useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../Pagination Component/paginationAndSearching";
import { TableLoading } from "react-bootstrap-table-loading";
import SkeletonTableRow from "../../SkeltonTable/skeletonTable";
import { useSelector } from "react-redux";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
//import './table.css';

export const VerificationTable = ({ column, rowsArr, addNewRow,updatedArray,handleSave ,isLoading,buttonLoading,buttonName}) => {
  const columns = useMemo(() => column, [column]);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [dataArr, setDataArr] = useState(rowsArr);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
 

 

  const handleCellChange = (rowIndex, columnId, value) => {
    // Update the data state with the new value
    const newData = [...rowsArr];
    newData[rowIndex][columnId] = value;
    setDataArr(newData);
    updatedArray(newData)
  };
  const handleDeleteRow = rowIndex => {
    const newData = [...rowsArr];
    newData.splice(rowIndex, 1);
    setDataArr(newData);
    updatedArray(newData);
  };

// Helper function to check if a specific action exists in a submenu
const hasAction = (submenu, actionName) => submenu.Actions.includes(actionName);

  // Find the "Invoice" menu
  const invoiceMenu = findSubMenuByName(permissions, 'Invoice');
  const invoiceListMenu = invoiceMenu ? findSubMenuByName(invoiceMenu.SubMenus, 'Invoice Verification') : null;
  const newSubMenu = invoiceListMenu ? findSubMenuByName(invoiceListMenu.SubMenus, 'Pending') : null;
  // const editSubMenu = newSubMenu ? findSubMenuByName(newSubMenu.SubMenus, 'Edit') : null;

  // Check if "Update" action exists in the "Edit" submenu
  const canVerify = newSubMenu ? hasAction(newSubMenu, 'Verify') : false;
  const canDelete = newSubMenu ? hasAction(newSubMenu, 'Delete') : false;


  return (
    <>
      <div className="card">
        <div className="card-header">
        <button
         disabled={canVerify?false:true}
                                    className="btn btn-primary"
                                    style={{
                                      background: "rgba(233, 133, 35, 0.84)",
                                      border: "none",
                                    }}
                                    onClick={() => {
                                      handleSave();
                                    }}
                                  >
                                 
                                    {isLoading ? buttonLoading : buttonName}
                                  </button>
          <button
                                               disabled={canVerify?false:true}
            className="btn btn-primary"
            style={{
              background: "rgba(233, 133, 35, 0.84)",
              border: "none",
            }}
            onClick={addNewRow}
          >
            Add new row +
          </button>
         
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows?.map((row, rowIndex) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => {
                          const zeroIndex = cellIndex == 0;
                          const firstIndex = cellIndex == 1;

                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black", whiteSpace: "normal" }}
                            >
                            {  zeroIndex && <div>
                              <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip">{"delete from list"}</Tooltip>}
                        >
                          {!canDelete?<>
                            <i
                            className="material-icons"
                            style={{
                              color: "red",
                              cursor:'not-allowed',
                              opacity:'0.5',
                              marginRight: "6px",
                            }}
                          >
                            delete
                          </i>
                          </>:
                                              <i
                                              className="material-icons"
                                              style={{
                                                color: "red",
                                                marginRight: "6px",
                                                cursor: "pointer",
                                              }}
                                        onClick={()=>{handleDeleteRow(rowIndex)}}
                                            >
                                              delete
                                            </i>
                          }
                        </OverlayTrigger>
                              </div>  || firstIndex && 
                                <textarea
                                disabled={canVerify?false:true}
                                style={{
                                  border: 'none',
                                  outline: 'none',
                                  padding: '8px',
                                  fontSize: '12px',
                                  width:'200px'
                                 
                              }}   placeholder={"Enter "+cell.column.Header}
                                  value={cell.value}
                                  onChange={(e) =>
                                    handleCellChange(
                                      rowIndex,
                                      cell?.column?.id,
                                      e.target.value
                                    )
                                  }
                                /> ||  <input
                                disabled={canVerify?false:true}
                                style={{
                                  border: 'none',
                                  outline: 'none',
                                  padding: '8px',
                                  fontSize: '12px',
                                  
                              }}
                                  value={cell.value}
                                  placeholder={"Enter "+cell.column.Header}
                                  onChange={(e) =>
                                    handleCellChange(
                                      rowIndex,
                                      cell?.column?.id,
                                      e.target.value
                                    )
                                  }
                                />}
                                
                            

                             
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>{" "}
                {/* {showLoading && <SkeletonTableRow cols={11} row ={4}/>} */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerificationTable;
